//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    ecomProduct: { type: Object, required: true },
    lePart: { type: String, default: null }
  },
  data () {
    return {
      headers: {
        'renegades-le_rfu': 'SEE MORE SunGod x RFU',
        'renegades-le_woodsy': 'SEE MORE SunGod x Woodsy',
        'vanguards-le_woodsy': 'SEE MORE SunGod x Woodsy',
        'classics3-le_mattjones': 'SEE MORE SunGod x Matt Jones',
        'classics3-le_airton': 'SEE MORE SunGod x Airton Cozzolino',
        'sierras-le_hannahwhiteley': 'SEE MORE SunGod x Hannah Whiteley',
        sns_fwt21: 'SEE MORE SunGod x FWT',
        vs_fwt21: 'SEE MORE SunGod x FWT',
        sns_pow21: 'SEE MORE SunGod x POW',
        vs_pow21: 'SEE MORE SunGod x POW',
        vs_billymorgan: 'SEE MORE SunGod x Billy Morgan',
        sns_billymorgan: 'SEE MORE SunGod x Billy Morgan',
        'velans-le_canyon': 'SEE MORE Canyon dhb SunGod'
      }
    }
  },
  computed: {
    header () {
      if (this.ecomProduct.sku in this.headers) return this.headers[this.ecomProduct.sku]
      if (this.lePart) return this.headers[this.lePart]
      return false
    }
  }
}
